module.exports = __webpack_public_path__ + "img/deftpower-logo.5691dbfa.svg";